"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.fixStateValue = fixStateValue;
exports.getInputClassName = getInputClassName;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _classnames5 = _interopRequireDefault(require("classnames"));
var _utils = require("../_utils");
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getInputClassName(prefixCls, disabled, readOnly, size, mSize, width, status, prefix, suffix) {
  var _classnames;
  if (prefix || suffix) {
    return prefixCls;
  }
  return (0, _classnames5.default)(prefixCls, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "is-disabled", disabled), (0, _defineProperty2.default)(_classnames, "is-readOnly", readOnly), (0, _defineProperty2.default)(_classnames, "is-".concat(status), status), (0, _defineProperty2.default)(_classnames, "size-".concat(size), size), (0, _defineProperty2.default)(_classnames, "m-size-".concat(mSize), mSize), (0, _defineProperty2.default)(_classnames, "size-".concat(width, "-width"), width), _classnames));
}
function fixStateValue(value) {
  if (typeof value === 'undefined' || value === null) {
    return '';
  }
  return value;
}
var Input = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('input');
  var _React$useState = React.useState(props.value === undefined ? props.defaultValue : props.value),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var wrapRef = React.useRef(null);
  React.useEffect(function () {
    if (props.value !== undefined) {
      setValue(props.value);
    }
  }, [[props.value]]);
  var focusCls = 'is-focus';
  var wrapEvents = {};
  var blurHandle = function blurHandle(e) {
    var _wrapRef$current, _props$onBlur;
    wrapRef === null || wrapRef === void 0 || (_wrapRef$current = wrapRef.current) === null || _wrapRef$current === void 0 ? void 0 : _wrapRef$current.classList.remove(focusCls);
    (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 ? void 0 : _props$onBlur.call(props, e);
  };
  var focusHandle = function focusHandle(e) {
    var _wrapRef$current2, _props$onFocus;
    wrapRef === null || wrapRef === void 0 || (_wrapRef$current2 = wrapRef.current) === null || _wrapRef$current2 === void 0 ? void 0 : _wrapRef$current2.classList.add(focusCls);
    (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 ? void 0 : _props$onFocus.call(props, e);
  };
  if (props.prefix || props.suffix) {
    wrapEvents = {
      onFocus: focusHandle,
      onBlur: blurHandle
    };
  }
  var handleChange = function handleChange(e) {
    var _props$onChange;
    setValue(e.target.value);
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, e);
  };
  var renderInput = function renderInput() {
    var className = props.className,
      disabled = props.disabled,
      readOnly = props.readOnly,
      size = props.size,
      mSize = props.mSize,
      width = props.width,
      status = props.status,
      prefix = props.prefix,
      suffix = props.suffix,
      addonBefore = props.addonBefore,
      addonAfter = props.addonAfter;
    var otherProps = (0, _utils.omit)(props, ['addonBefore', 'addonAfter', 'prefix', 'suffix', 'size', 'mSize', 'status', 'defaultValue']);
    return /*#__PURE__*/React.createElement("input", (0, _extends2.default)({
      ref: ref
    }, otherProps, wrapEvents, {
      onChange: handleChange,
      className: (0, _classnames5.default)(getInputClassName(prefixCls, disabled, readOnly, size, mSize, width, status, prefix, suffix), (0, _defineProperty2.default)({}, "".concat(className), !prefix && !suffix && !addonBefore && !addonAfter && className))
    }));
  };
  var renderInputWithLabel = function renderInputWithLabel(v, inputElement) {
    var _classnames3;
    var className = props.className,
      size = props.size,
      mSize = props.mSize,
      addonBefore = props.addonBefore,
      addonAfter = props.addonAfter;
    if (!addonBefore && !addonAfter) {
      return /*#__PURE__*/React.cloneElement(inputElement, {
        value: v
      });
    }
    var groupClassName = "".concat(prefixCls, "--group");
    var cellCls = "".concat(groupClassName, "__cell");
    var textCls = "".concat(groupClassName, "__text");
    var mergeGroupClassName = (0, _classnames5.default)(groupClassName, className, (_classnames3 = {}, (0, _defineProperty2.default)(_classnames3, "size-".concat(size), size), (0, _defineProperty2.default)(_classnames3, "m-size-".concat(mSize), mSize), _classnames3));
    var addonBeforeNode = addonBefore ? /*#__PURE__*/React.createElement("div", {
      className: textCls
    }, /*#__PURE__*/React.createElement("span", null, addonBefore)) : null;
    var addonAfterNode = addonAfter ? /*#__PURE__*/React.createElement("div", {
      className: textCls
    }, /*#__PURE__*/React.createElement("span", null, addonAfter)) : null;
    return /*#__PURE__*/React.createElement("div", {
      className: mergeGroupClassName
    }, addonBeforeNode, /*#__PURE__*/React.createElement("div", {
      className: cellCls
    }, /*#__PURE__*/React.cloneElement(inputElement, {
      value: value
    })), addonAfterNode);
  };
  var renderLabeledFix = function renderLabeledFix(v, inputElement) {
    var _classnames4;
    var className = props.className,
      prefix = props.prefix,
      suffix = props.suffix,
      size = props.size,
      mSize = props.mSize,
      width = props.width,
      disabled = props.disabled,
      readOnly = props.readOnly,
      status = props.status;
    if (!prefix && !suffix) {
      return /*#__PURE__*/React.cloneElement(inputElement, {
        value: v
      });
    }
    var wrapperClassName = "".concat(prefixCls, "--wrap");
    var prefixNodeCls = "".concat(prefixCls, "--wrap__prefix");
    var suffixNodeCls = "".concat(prefixCls, "--wrap__suffix");
    var mergeWrapperClassName = (0, _classnames5.default)(wrapperClassName, className, (_classnames4 = {}, (0, _defineProperty2.default)(_classnames4, "is-disabled", disabled), (0, _defineProperty2.default)(_classnames4, "is-readonly", readOnly), (0, _defineProperty2.default)(_classnames4, "is-".concat(status), status), (0, _defineProperty2.default)(_classnames4, "size-".concat(size), size), (0, _defineProperty2.default)(_classnames4, "m-size-".concat(mSize), mSize), (0, _defineProperty2.default)(_classnames4, "size-".concat(width, "-width"), width), _classnames4));
    var prefixNode = prefix ? /*#__PURE__*/React.createElement("div", {
      className: prefixNodeCls
    }, prefix) : null;
    var suffixNode = suffix ? /*#__PURE__*/React.createElement("div", {
      className: suffixNodeCls
    }, suffix) : null;
    return /*#__PURE__*/React.createElement("div", {
      className: mergeWrapperClassName,
      ref: wrapRef
    }, prefixNode, /*#__PURE__*/React.cloneElement(inputElement, {
      value: value
    }), suffixNode);
  };
  return renderInputWithLabel(fixStateValue(value), renderLabeledFix(fixStateValue(value), renderInput()));
});
Input.defaultProps = {
  type: 'text'
};
var _default = exports.default = Input;